import type { IconSvgObject } from './types';

const Door02Icon: IconSvgObject = [
  ["path", { d: "M5 22V8C5 5.17157 5 3.75736 5.87868 2.87868C6.75736 2 8.17157 2 11 2H13C15.8284 2 17.2426 2 18.1213 2.87868C19 3.75736 19 5.17157 19 8V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 22H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15.125 12H15M15.25 12C15.25 12.1381 15.1381 12.25 15 12.25C14.8619 12.25 14.75 12.1381 14.75 12C14.75 11.8619 14.8619 11.75 15 11.75C15.1381 11.75 15.25 11.8619 15.25 12Z", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }]
];

export default Door02Icon;
